import { render, staticRenderFns } from "./BitQLoginPage.vue?vue&type=template&id=7a72b2bf&scoped=true"
import script from "./BitQLoginPage.vue?vue&type=script&lang=js"
export * from "./BitQLoginPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a72b2bf",
  null
  
)

export default component.exports